// import { IThemeProps } from "component/theme";
import DefaultUptimeTheme from 'component/theme/defaultTheme';
import styled from "styled-components";

export interface IUploadContainerProps {
  theme: typeof DefaultUptimeTheme;
  // theme: IThemeProps;
}

export const ContainerStyled = styled('div')<IUploadContainerProps>`
  ${({ theme }: IUploadContainerProps) => `
  &.upload-container {
    &.disabled {
      opacity: 0.5;
      .MuiDropzoneArea-root{
        cursor: unset;
        a {
          text-decoration: none;
          color: ${theme.uptimeColors.generalColors.button.hyperlink.enabled} !important;
        }
      }
    }
    .MuiDropzoneArea-root {
      height: 120px;
      min-height: initial;
      border-radius: 20px;
      .MuiDropzonePreviewList-root {
        display: none;
      }
      .MuiDropzoneArea-textContainer {
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        justify-content: center;    
        .MuiDropzoneArea-text{
          font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
          div{
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          margin-bottom: ${theme.uptimeSpace[0]};
        }
      }
      .MuiDropzoneArea-icon {
        width: 51px;
        height: 51px;
      }
      p {
        margin-top: ${theme.uptimeSpace[5]}px;
        font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
        line-height: ${theme.uptimeLineHeights.desktop.lh4}px;
        font-weight: normal;
        color: ${theme.uptimeColors.grayScales.black};
        a {
          color: ${theme.uptimeColors.generalColors.button.hyperlink.enabled};
        }
        a:hover {
          color: ${theme.uptimeColors.generalColors.button.hyperlink.hover};
        }
      }
    }
    .upload-error {
      font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
      line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
      margin-top: ${theme.uptimeSpace[2]}px;
      color: ${theme.colors.state.danger};
      text-align: center;
      word-wrap: break-word;
    }
    .upload-config {
      color: ${theme.uptimeColors.grayScales.darkerGray};
      font-size: ${theme.uptimeFontSizes.desktop.fz1}px;
      font-weight: normal;
      padding: ${theme.uptimeSpace[2]}px  ${theme.uptimeSpace[0]}  ${theme.uptimeSpace[0]}  ${theme.uptimeSpace[5]}px;
      line-height: 1.3;
    }
  
    &-full-width {
      .MuiDropzoneArea-root {
        font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
        width: 100%;
      }
    }
  }`}
`;
